export const PRIVACY_POLICY_CHANGE_LOCAL_STORAGE_KEY = 'HAS_SEEN_PRIVACY_POLICY_CHANGE';
